var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "800px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.personList, border: "", size: "small" } },
        [
          _c("el-table-column", {
            attrs: { prop: "userName", label: "人员", width: "100" }
          }),
          _c("el-table-column", {
            attrs: { prop: "stationName", label: "岗位", width: "100" }
          }),
          _c("el-table-column", {
            attrs: { prop: "businessNum", label: "订单数", width: "80" }
          }),
          _vm.showGrossProfit
            ? _c("el-table-column", {
                attrs: {
                  prop: "grossProfitTotal",
                  label: "毛利总额",
                  width: "120"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.formatGrossProfitTotal(
                                scope.row.grossProfitTotal
                              )
                            )
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3056369663
                )
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { prop: "provisionAmount", label: "提成金额", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm.formatAmount(scope.row.provisionAmount)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "规则明细", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.ruleDetails, function(r, i) {
                    return _c("div", { key: i, staticClass: "rule-line" }, [
                      _vm._v(
                        " " +
                          _vm._s(r.ruleName) +
                          ": " +
                          _vm._s(_vm.formatAmount(r.amount)) +
                          " "
                      ),
                      r.calcFormula || r.formula
                        ? _c("span", { staticClass: "formula" }, [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  _vm.formatFormula(r.calcFormula || r.formula)
                                ) +
                                ")"
                            )
                          ])
                        : _vm._e()
                    ])
                  })
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }